(() => {
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let motionObserver;

  const initMotion = (root = document) => {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('sky300-motion-ready');

    if (!motionObserver) {
      motionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            motionObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    const targets = root.querySelectorAll(
      '.sky300-section__eyebrow, .sky300-section__title, .sky300-section__intro, .sky300-trust-strip__item, .sky300-vehicle-card, .sky300-featured-product__shell, .sky300-header-card, .sky300-social-card, .sky300-catalog-vehicle, .sky300-contact-workflow, .sky300-about-method__grid article, .sky300-faq-list details, .sky300-product-assurance, .sky300-product-details__content'
    );

    targets.forEach((element, index) => {
      if (element.dataset.sky300Motion === 'ready') return;
      element.dataset.sky300Motion = 'ready';
      element.classList.add('sky300-reveal');
      element.style.setProperty('--sky300-delay', `${Math.min(index % 5, 4) * 70}ms`);
      motionObserver.observe(element);
    });
  };

  const updateHeaderButton = () => {
    if (!document.querySelector('.sky300-header-assurance')) return;

    const buttonLabel = document.querySelector('.product-form__submit span');
    if (!buttonLabel || buttonLabel.closest('button')?.disabled) return;

    const desiredLabel = isEnglish ? 'Order made to order' : 'Ordenar sobre pedido';
    if (buttonLabel.textContent.trim() !== desiredLabel) buttonLabel.textContent = desiredLabel;
  };

  document.addEventListener('click', (event) => {
    const mobileButton = event.target.closest('[data-sky300-mobile-buy]');
    const whatsappLink = event.target.closest('[data-sky300-whatsapp]');

    if (whatsappLink) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sky300_header_whatsapp', product: whatsappLink.dataset.product });
    }

    if (!mobileButton) return;

    const productButton = mobileButton.closest('product-info')?.querySelector('.product-form__submit:not([disabled])');
    if (productButton) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sky300_mobile_order', product: mobileButton.dataset.product });
      productButton.click();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        updateHeaderButton();
        initMotion();
      },
      { once: true }
    );
  } else {
    updateHeaderButton();
    initMotion();
  }

  document.addEventListener('shopify:section:load', (event) => initMotion(event.target));

  if (document.querySelector('.sky300-header-assurance')) {
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length > 0)) updateHeaderButton();
    });
    const productInfo = document.querySelector('product-info');
    if (productInfo) observer.observe(productInfo, { childList: true, subtree: true });
  }
})();
